import React, { FC, useEffect, useState } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnter } from 'src/utils/changeEnter';
import $ from 'jquery';

const MultipleChoiceSurvey: FC = () => {
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let text = useSelector((state: RootState) => state.editText.text);
  let btnText = useSelector((state: RootState) => state.buttons.btnText);

  const page_len = bgImage?.background?.length - 1;

  const [selected, setSelected] = useState([]);
  useEffect(() => {
    $('.survey_action_line').css(
      'width',
      `${(currentIndex / page_len) * 100}%`
    );
    setSelected([]);
  }, [currentIndex]);

  return (
    <div className="root_view">
      <div className="template">
        <div className="center_horizon top_wrapper">
          {currentIndex !== 0 ? (
            <button className="back_btn">close</button>
          ) : (
            <div />
          )}
          <button className="close_btn">close</button>
        </div>
        <div className="center_wrapper">
          <div>
            <div className="title">
              <div className="title_inner">
                {changeEnter(text?.title?.[currentIndex])}
              </div>
            </div>
            <div className="sub_title">
              <div className="sub_inner_title">
                {changeEnter(text?.sub_title?.[currentIndex])}
              </div>
            </div>
          </div>

          <div className="survey_wrapper">
            <div className="survey_line">
              <div className="survey_action_line" />
            </div>
            {btnText?.option_button?.[currentIndex]?.map(
              (survey: string, idx: number) => {
                return (
                  <div
                    key={idx}
                    className="survey"
                    onClick={() => {
                      let newSelected = selected.slice();
                      let selectedIndex = newSelected.indexOf(idx);
                      if (selectedIndex === -1) {
                        newSelected.push(idx);
                      } else {
                        newSelected.splice(selectedIndex, 1);
                      }
                      setSelected(newSelected);
                    }}
                  >
                    <button
                      className={selected.indexOf(idx) !== -1 ? 'action' : ''}
                    >
                      {survey}
                    </button>
                  </div>
                );
              }
            )}
          </div>
        </div>
        <div className="center_horizon btn_wrapper">
          <button className={selected.length !== 0 && 'action'}>
            {btnText?.button?.[currentIndex]}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MultipleChoiceSurvey;
